import { render } from "./Header.vue?vue&type=template&id=4442d3f5"
const script = {}

import "./Header.vue?vue&type=style&index=0&id=4442d3f5&lang=css"

import exportComponent from "/tmp/workspace1/source/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__